module.exports = __webpack_public_path__ + "img/marshasylvia.2e482097.png";